import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";
import { Building, Promotion } from "@/constants/objects";

interface ResidentFiltersProps {
  buildings: Building[];
  promotions: Promotion[];
  filters: {
    search: string;
    buildingId: string;
    promotionId: string;
  };
  onChange: (filters: ResidentFiltersProps["filters"]) => void;
}

export function ResidentFilters({
  buildings,
  promotions,
  filters,
  onChange,
}: ResidentFiltersProps) {
  const handleClear = () => {
    onChange({
      search: "",
      buildingId: "",
      promotionId: "",
    });
  };

  return (
    <div className="flex space-x-3 items-center w-full mb-4">
      <Input
        placeholder="Search by email"
        value={filters.search}
        onChange={(e) => onChange({ ...filters, search: e.target.value })}
        className="max-w-sm"
      />
      <Select
        value={filters.buildingId}
        onValueChange={(value) => onChange({ ...filters, buildingId: value })}
      >
        <SelectTrigger className="w-[180px]">
          <SelectValue placeholder="Buildings" />
        </SelectTrigger>
        <SelectContent>
          {buildings.map((building) => (
            <SelectItem key={building._id} value={building._id}>
              {building.title}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      <Select
        value={filters.promotionId}
        onValueChange={(value) => onChange({ ...filters, promotionId: value })}
      >
        <SelectTrigger className="w-[180px]">
          <SelectValue placeholder="Promotions" />
        </SelectTrigger>
        <SelectContent>
          {promotions.map((promotion) => (
            <SelectItem key={promotion.id} value={promotion.id}>
              {promotion.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      <Button
        variant={"outline"}
        className={"hover:bg-primary hover:text-white p-2"}
        onClick={handleClear}
        size={"icon"}
      >
        <X />
      </Button>
    </div>
  );
}
